import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RmColumnDto } from './rm-column-dto';


export class RmColumnResponse extends GlobalResponseObject{
    data?: RmColumnDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RmColumnDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 